export default function ArrowRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
        <path d="M2 12L7 7L2 2" strokeWidth="1.5" strokeLinecap="square"/>
    </svg>
  );
}
